import { X } from "lucide-react";
import { useEffect } from "react";

export function Modal({ children, onClose, title, testId, wide }) {
  // Close on ESC — hooks into the document key listener rather than the
  // modal's own tabindex so it works even when focus is inside a child
  // input/select. Cleaned up on unmount to avoid stale handlers.
  useEffect(() => {
    if (!onClose) return;
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" data-testid={testId}>
      <div className={`border border-[#27272A] bg-[#121212] w-full ${wide ? "max-w-4xl" : "max-w-2xl"} max-h-[90vh] overflow-y-auto`}>
        <div className="px-6 py-4 border-b border-[#27272A] flex items-center justify-between">
          <div>
            <div className="label-mute">Form</div>
            <h3 className="font-display text-2xl uppercase font-bold tracking-tight">{title}</h3>
          </div>
          <button onClick={onClose} className="p-1 hover:text-[#FF3B30] transition-colors" data-testid="modal-close-button">
            <X className="size-5" />
          </button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
